// wedding favors form controller



var optionValue = 1;

$(document).on('click', '.flavor-plus', function() {
  optionValue = optionValue + 1;

  $('#wedding-options').append('<div class="row"><div class="col-sm-8"><select name="contact[Flavor_' + optionValue + ']" id=""><option value="Asheville Mix">Asheville Mix</option><option value="Atlanta Mix">Atlanta Mix</option><option value="Birthday Confetti">Birthday Confetti</option><option value="Caramel Apple">Caramel Apple</option><option value="Cheddar">Cheddar</option><option value="Cheese Lovers">Cheese Lovers</option><option value="Chili Cheese">Chili Cheese</option><option value="Chocolate Peanut Butter">Chocolate Peanut Butter</option><option value="Chocolate Peppermint Bark">Chocolate Peppermint Bark</option><option value="Cinnamon Bourbon Pecan">Cinnamon Bourbon Pecan</option><option value="Cotton Candy">Cotton Candy</option><option value="Dark Chocolate & Cherries">Dark Chocolate & Cherries</option><option value="Dark Chocolate Pretzel">Dark Chocolate Pretzel</option><option value="Dill Pickle">Dill Pickle</option><option value="Dynamite Coffee Toffee">Dynamite Coffee Toffee</option><option value="Everything Bagel">Everything Bagel</option><option value="Gingerbread">Gingerbread</option><option value="Jalapeño Cheddar">Jalapeño Cheddar</option><option value="Monster Mix">Monster Mix</option><option value="Parmesan & Black Pepper">Parmesan & Black Pepper</option><option value="Pimento Cheese">Pimento Cheese</option><option value="Poppy Mix">Poppy Mix</option><option value="Pumpkin Spice Caramel">Pumpkin Spice Caramel</option><option value="Reindeer Crunch">Reindeer Crunch</option><option value="Salted Caramel">Salted Caramel</option><option value="Salt & Pepper">Salt & Pepper</option><option value="Southern Pecan Pie">Southern Pecan Pie</option><option value="Spicy Thai">Spicy Thai</option><option value="Spring Confetti">Spring Confetti</option><option value="Sweet Onion">Sweet Onion</option><option value="Vegan Salted Caramel">Vegan Salted Caramel</option><option value="White Cheddar">White Cheddar</option></select></div><div class="col-sm-4"><div class="qty-wrapper"><input type="number" id="Quantity" name="contact[Quantity_' + optionValue + ']" value="1" min="1" class="qty" pattern="[0-9]*"></div></div></div>');


  buildQtyControl();
});



// prevents widows/orphans 
$(function($) {
    $('.rte p').each(function() {
        $(this).html($(this).html().replace(/\s([^\s<]+)\s*$/,'&nbsp;$1'));
    });
});

// accordion setup for faq sections and product descriptions
$(document).ready(function($) {
  $('#accordion').find('.accordion-toggle').click(function(){
    //Expand or collapse this panel
    
    $(this).next().slideToggle('fast');
    $(this).toggleClass('open');
    //Hide the other panels
    $(".accordion-content").not($(this).next()).slideUp();
    $('.accordion-toggle').not($(this)).removeClass('open');
  });
});

// back to top button controls
// When the user scrolls down 20px from the top of the document, show the button
// if ($(window).width() <= 800){
//   window.onscroll = function() {scrollFunction()};
// };

// function scrollFunction() {
//   if (document.body.scrollTop > 260 || document.documentElement.scrollTop > 260) {
//     document.getElementById("back-to-top").style.display = "block";
//   } else {
//     document.getElementById("back-to-top").style.display = "none";
//   }
// }

// // When the user clicks on the button, scroll to the top of the document
// function topFunction() {
//   document.body.scrollTop = 0;
//   document.documentElement.scrollTop = 0;
// }


// creates and controls custom quantity changers 
$(document).ready(function () {
  buildQtyControl();
});

function buildQtyControl() {
  jQuery('<div class="quantity-nav-left"><div class="quantity-button quantity-down">&mdash;</div></div>').insertBefore('.qty-wrapper input');
  jQuery('<div class="quantity-nav-right"><div class="quantity-button quantity-up">+</div></div>').insertAfter('.qty-wrapper input');
  jQuery('.qty-wrapper').each(function () {
    var spinner = jQuery(this),
      input = spinner.find('input[type="number"]'),
      btnUp = spinner.find('.quantity-up'),
      btnDown = spinner.find('.quantity-down'),
      min = input.attr('min'),
      max = input.attr('max');

    btnUp.click(function () {
      var oldValue = parseFloat(input.val());
      if (oldValue >= max) {
        var newVal = oldValue;
      } else {
        var newVal = oldValue + 1;
      }
      spinner.find("input").val(newVal);
      spinner.find("input").trigger("change");
    });

    btnDown.click(function () {
      var oldValue = parseFloat(input.val());
      if (oldValue <= min) {
        var newVal = oldValue;
      } else {
        var newVal = oldValue - 1;
      }
      spinner.find("input").val(newVal);
      spinner.find("input").trigger("change");
    });
  })
}

// cart quantity control

jQuery('.cart__update-wrapper').each(function() {
  var spinner = jQuery(this),
    input = spinner.find('input[type="number"]'),
    btnUp = spinner.find('.quantity-up'),
    btnDown = spinner.find('.quantity-down'),
    min = input.attr('min'),
    max = input.attr('max');

  btnUp.click(function() {
    var oldValue = parseFloat(input.val());
    if (oldValue >= max) {
      var newVal = oldValue;
    } else {
      var newVal = oldValue + 1;
    }
    spinner.find("input").val(newVal);
    spinner.find("input").trigger("change");
  });

  btnDown.click(function() {
    var oldValue = parseFloat(input.val());
    if (oldValue <= min) {
      var newVal = oldValue;
    } else {
      var newVal = oldValue - 1;
    }
    spinner.find("input").val(newVal);
    spinner.find("input").trigger("change");
  });

});
